<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="$t('nav.clients')" :title="$t('client.listTitle')">
      <div class="list__buttons">
        <MainButton @click.native="handleCreate()">Create</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="list__filter">
        <div class="list__filter-item ids">
          <input type="text" v-model="filterData.client_name" placeholder="Name" />
        </div>

        <div class="list__filter-button">
          <MainButton @click.native="filterList()">Filter</MainButton>
        </div>
        <div class="list__filter-button">
          <MainButton @click.native="filterListReset()">Reset</MainButton>
        </div>
      </div>

      <div class="list">
        <div v-if="clientsList.length">
          <CustomTable
            v-if="clientsList.length"
            :data="clientsList"
            :deleted-keys="tableOptions.deletedKeys"
            :rename-columns="tableOptions.renameColumn"
            :custom-order="tableOptions.customOrder"
            :is-action-block-visible="tableOptions.isActionBlockVisible"
            :handle-delete="handleDelete"
            :handleFilter="handleFilter"
            :handle-edit="handleEdit"
            :direction="directionSort"
            :order="orderSort"
            :noSortColumn="tableOptions.noSortColumn"
            :name="'clients'"
          >
          </CustomTable>
          <div class="pagination">
            <Pagination
              :maxPage="clients.lastPage"
              :page="page"
              :urlList="'CLIENT_LIST'"
              :totalItem="clients.total"
            />
          </div>
        </div>
        <div class="list__no-have" v-else>No clients found by this parameter.</div>
      </div>
    </ContentContainer>

    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />

    <MainModal v-if="deleteModal" :on-close="handleCloseConfirmModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-title">
          Do you want to delete the Client - {{ deleteRow.name }}?
        </div>
        <div class="list__confirm-buttons">
          <div class="list__confirm-button">
            <MainButton buttonWhite @click.native="handleCloseConfirmModal">CANCEL</MainButton>
          </div>
          <div class="list__confirm-button">
            <MainButton @click.native="handleDeleteRow" :button-cancel="true">DELETE</MainButton>
          </div>
        </div>
      </div>
    </MainModal>

    <MainModal v-if="detailModal" :on-close="handleCloseDetailModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-column">
          <div class="list__confirm-title">Detail</div>
        </div>

        <div class="list__confirm-column">
          <div class="list__confirm-title">Log List</div>
        </div>
      </div>
    </MainModal>

    <MainModal v-if="deleteModalSuccess" :on-close="handleCloseSuccessModal">
      <div class="list__success-delete">Client {{ deleteRow.name }} successfully deleted.</div>
    </MainModal>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import leadApi from "~/api/lead";
import moment from "moment";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ModalError from "~/components/molecules/ModalError.vue";

export default {
  name: "ClientsList",
  metaInfo: {
    title: "Clients List",
  },
  data() {
    return {
      logsModal: false,
      logsModalArray: [],
      deleteModal: false,
      deleteRow: null,
      deleteModalSuccess: false,
      directionSort: false,
      orderSort: "id",

      detailModal: false,
      chosenLead: null,

      filterData: {
        client_name: "",
      },
      isFilter: false,

      tableOptions: {
        deletedKeys: ["null"],
        noSortColumn: ["integrations_count", "integrations_active"],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "id",
            to: "ID",
          },
          {
            from: "name",
            to: "Name",
          },
          {
            from: "is_active",
            to: "Active",
          },
          {
            from: "integrations_count",
            to: "Integrations Count",
          },
          {
            from: "integrations_active",
            to: "Integrations Active",
          },
        ],
        customOrder: [
          "id",
          "name",
          "is_active",
          "integrations_count",
          "integrations_active",
          "null",
        ],
      },
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    CustomTable,
    Pagination,
    MainModal,
    ModalError,
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeyDown);
  },
  mounted() {
    window.addEventListener("keydown", this.onKeyDown);
    this.getList();
  },
  watch: {
    $route(to, from) {
      this.getList();
    },
  },
  computed: {
    ...mapState("lead", ["error", "loadingProcess", "clients", "clientsList"]),
    page() {
      return +this.$route.params.page;
    },
  },
  methods: {
    onKeyDown(e) {
      if (e.key === "Enter") {
        this.filterList();
      }
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    getList() {
      let url = `?page=${this.page}&perPage=20&with[0]=integrations`;
      if (this.orderSort.length) {
        url = url + `&sortField=${this.orderSort}&sortDest=${this.directionSort ? "asc" : "desc"}`;
      }

      if (this.isFilter) {
        if (this.filterData.client_name.length) {
          url += `&name=${this.filterData.client_name}`;
        }
      }

      this.$store.dispatch("lead/getClientsList", url);
    },

    filterList() {
      this.isFilter = true;
      if (this.page > 1) {
        this.$router.push({
          path: ROUTE.CLIENT_LIST.replace(":page", 1),
        });
      } else {
        this.getList();
      }
    },
    filterListReset() {
      this.isFilter = false;
      this.getList();
      this.filterData.integration_name = "";
      this.filterData.client = null;
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getList();
    },
    handleCreate() {
      this.$router.push({
        path: ROUTE.CLIENT_CREATE,
      });
    },
    handleDelete(row) {
      this.deleteModal = true;
      this.deleteRow = row;
    },
    handleEdit(row) {
      this.$router.push({
        path: ROUTE.CLIENT_EDIT.replace(":id", `${row.id}`),
      });
    },
    handleDetail(row) {
      this.detailModal = true;
      this.chosenLead = this.leadsList.find((item) => item.id === row.id);
    },
    handleCloseDetailModal() {
      this.detailModal = false;
      this.chosenLead = null;
    },
    handleCloseConfirmModal() {
      this.deleteModal = false;
    },
    handleDeleteRow() {
      const url = `/${this.deleteRow.id}`;
      this.$store.commit("lead/setLoading", true);
      leadApi
        .deleteClient(url)
        .then((res) => {
          this.$store.commit("lead/setLoading", false);
          if (res.success) {
            this.getList();
            this.handleCloseConfirmModal();
            this.deleteModalSuccess = true;
          }
        })
        .catch((error) => {
          this.$store.commit("lead/setLoading", false);
          console.log(error);
        });
    },
    handleCloseSuccessModal() {
      this.deleteModalSuccess = false;
    },
    closeModal() {
      this.error = null;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.custom-table__header,
/deep/.custom-table__row {
  grid-template-columns: 0.4fr 1fr 0.5fr 1fr 1fr 0.3fr !important;
}

.list {
  &__filter {
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__filter-item {
    width: 150px;
    margin-right: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    &.id {
      width: 100px;
    }

    input {
      padding: 5px 10px;
      font-size: 14px;
      width: 100%;
      height: 40px;
    }
  }

  &__filter-button {
    width: 100px;
    margin-right: 10px;
    padding-bottom: 10px;
  }

  &__modal-log-detail-button {
    padding: 10px 0;
    font-weight: 700;
    cursor: pointer;
  }

  &__modal-log-detail {
    background: rgb(39, 39, 39);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    overflow-y: auto;
  }
}
</style>
